export function createRoutes() {
  return [
    {
      path: 'report',
      component: () => import(/* webpackChunkName: "reportChrome" */ '@/report/ReportChrome.vue'),
      children: [
        {
          path: '',
          name: 'reportSummary',
          component: () => import(/* webpackChunkName: "reportSummary" */ '@/report/ReportSummary.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
